
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/di-cloud",
      function () {
        return require("private-next-pages/di-cloud.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/di-cloud"])
      });
    }
  